import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { HomeNavigationComponent } from './home-navigation/home-navigation.component';
import { HomeFooterComponent } from './home-footer/home-footer.component';
import { LeadDialog } from './home-footer/home-footer.component';

import { SignupComponent } from '../home/signup/signup.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatDialogModule} from '@angular/material/dialog';
import { GyvMartdlgComponent } from './home-navigation/home-navigation.component';
import { LandingpagesComponent } from './landingpages/landingpages.component';

import {MatTabsModule} from '@angular/material/tabs';
import { DemoComponent } from './landingpages/landingpages.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { StrategicpartnerComponent } from './strategicpartner/strategicpartner.component';
//import { BiddingSignupComponent } from './bidding-signup/bidding-signup.component';
import { MatCardModule } from '@angular/material/card';
import { CustomerwinsComponent } from './customerwins/customerwins.component';
import { webinarComponent } from '../webinarlive/webinarlive.component';

//import Swal from 'sweetalert2';

@NgModule({
  declarations: [
  //  NotFoundComponent,        
    HomeComponent,
    HomeNavigationComponent,
    HomeFooterComponent,
    LeadDialog,
   
    GyvMartdlgComponent,
    LandingpagesComponent,
    DemoComponent,
    TestimonialsComponent,
    StrategicpartnerComponent,
    //BiddingSignupComponent,
    CustomerwinsComponent,
    webinarComponent
    //ItsolutionsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TypeaheadModule.forRoot(),
   
    FormsModule,
    ReactiveFormsModule,
  
    MatDialogModule,
    MatTabsModule,
    MatCardModule,
  
    
  ],
  exports:[
    RouterModule,
    HomeComponent,
    HomeNavigationComponent,
    HomeFooterComponent
   
  ]
})
export class HomeModule { }
